import React, { useEffect, useState } from "react";
import Icons from "../../../../../../Config/Images";
import "./InitialRewardPointScreen.css";
import Header from "../../../../Layout/Header/Header";
import Footer from "../../../../Layout/Footer/Footer";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getRewardPointUnitsAPI } from "../../../../../../Store/Action/rewardPointsAction";
import CustomRewardPoints from "../../../../CustomComponents/CustomRewardPoints";

const InitialRewardPointScreen = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [unitCards, setUnitCards] = useState([]);

  const targets = [
    { name: "Gold Products", progress: 23.88 },
    { name: "Silver Products", progress: 80 },
    { name: "Platinum Products", progress: 30 },
    { name: "Diamond Products", progress: 20 },
  ];
  useEffect(() => {
    dispatch(
      getRewardPointUnitsAPI({}, (result) => {
        setUnitCards(result?.data || []);
      })
    );
  }, [dispatch]);
  const handleExploreRewardBtnClick = () => {
    if (unitCards?.length > 1) {
      navigate("/my-account/reward-points", {
        state: {
          rewardPointUnitId: Number(unitCards?.[0]?.reward_point_unit_id),
        },
      });
    } else if (unitCards?.length == 1) {
      navigate("/my-account/reward-tickets");
    }
  };
  return (
    <>
      <Header />

      <div className="reward-container">
        <div className="reward-image-wrapper">
          <img src={Icons.free_world_tour_img} alt="Free World Tour" />
        </div>

        <div className="reward-action">
          <button
            className="explore-reward-point-btn"
            onClick={() => handleExploreRewardBtnClick()}
          >
            {/* 🚀 Explore Reward Points */}
            Explore Reward Points
          </button>
        </div>
      </div>
      {/* <CustomRewardPoints
        progress={50}
        headerText="Reward Points"
        imageSrc={Icons.free_world_tour_img}
        targets={targets}
      /> */}
      {/* <CustomRewardPoints
        progress={overallProgress}
        headerText={headerTextName}
        imageSrc={Icons.free_world_tour_img}
        targets={targets}
        rewardForIndividualProductFlag={true}
      /> */}
      <Footer />
    </>
  );
};

export default InitialRewardPointScreen;
